import { ITemplateCategory } from '../constants/templates';
import { TEMPLATE_CATEGORY_BDC } from '../constants/templates';

/**
 * Check if a category is BDC and has subcategories
 *
 * @param {ITemplateCategory} category - The category to check
 * @returns {boolean} - True if the category is BDC and has subcategories
 */
export const hasSubcategories = (category: ITemplateCategory): boolean => {
    const isBDC = category.id === TEMPLATE_CATEGORY_BDC;
    return Boolean(
        isBDC && category.subcategories && category.subcategories.length > 0
    );
};
